/// <amd-module name="typeahead/features/ShowEssHelper" />

import {Experiment} from "typeahead/core/Experiment";
import {IExperimentalFeature} from "typeahead/core/IExperimentalFeature";
import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";
import {IDropdownContentHandler} from "typeahead/core/presentation/IDropdownContentHandler";
import * as StripingConfiguration from "typeahead/core/StripingConfiguration";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";
import {TypeaheadUtils} from "typeahead/core/TypeaheadUtils";

const configuration: IStripingConfiguration[] = [
    {
        deviceTypes: ["Desktop"],
        experiment: {
            id: 25824,
            name: "ESS_Helper",
        },
        lobs: ["HOTELS"],
    },
];

const linkHtml: string = `
    <a aria-label="Feedback" class="feedback" href="#" onclick="return false;"
        style="color:#616161; font-size:12px; width:auto; float:left;" >
        <span class="icon icon-comment"></span> Need help with the suggestions you see?
    </a>
`;

export class ShowEssHelper implements IDropdownContentHandler, IExperimentalFeature {
    private static essHelperJsPromise: JQueryPromise<void>;

    private static execute(event: JQueryEventObject): void {
        ShowEssHelper.showInterstitial();
        setTimeout(() => {
            if (!ShowEssHelper.essHelperJsPromise) {
                const essHelperJsDeferred: JQueryDeferred<void> = $.Deferred<void>();
                ShowEssHelper.essHelperJsPromise = essHelperJsDeferred.promise();
                const essHelperJsUrl = ShowEssHelper.getEssHelperJsUrl();
                if (essHelperJsUrl) {
                    $.getScript(essHelperJsUrl, () => {
                        essHelperJsDeferred.resolve();
                    });
                }
            }

            ShowEssHelper.essHelperJsPromise.done(() => {
                require(["EssHelper"], (essHelper) => {
                    essHelper.open(event.data);
                });
            });
        }, 0);
    }

    private static getEssHelperJsUrl(): string {
        const utaBundleUrl = TypeaheadUtils.getUtaBundleUrl();
        return utaBundleUrl ? utaBundleUrl.replace("universal_typeahead_bundle", "ess_helper") : undefined;
    }

    private static showInterstitial(): void {
        uitk.publish("results.changed", {
            contentId: ".wrap",
            disable: true,
            message: "Launching Search and Suggest Helper",
            scrollToTop: false,
            showLoader: true,
        });
        // Hide interstitial in case of timeout
        setTimeout(() => {
            uitk.publish("results.complete", {
                ariaLevel: "polite",
                contentId: ".wrap",
            });
        }, 10000);
    }

    public handleContentToShow($dropDownElement: JQuery, $inputElement: JQuery, context: IContext): void {
        if (ExecutionHelper.shouldExecute(context, configuration)) {
            const $linkHtml = $(linkHtml);
            $linkHtml.on("click", null, $inputElement.attr("id"), ShowEssHelper.execute);
            $dropDownElement.find("footer.footer").prepend($linkHtml);
        }
    }

    public getExperiments(): Experiment[] {
        return StripingConfiguration.getExperiments(configuration);
    }
}
